export default "__VITE_ASSET__DUi6N6iR__"